var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":_vm.pais.nombre,"subtitle":"Paises","back-to":"/paises"}}),_c('formulario',{attrs:{"pais":_vm.pais},on:{"submit":_vm.actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }